export default "__VITE_ASSET__omznv1t1__"